export default {
  sidebar: {
    title: 'Кабинет мерчанта',
    transactions: 'Транзакции',
    payout: 'Payout',
  },
  settings: {
    logout: 'Выход',
  },
  transactions: {
    pageSize: 'Размер страницы',
    datePlaceholder: 'Введите дату',
    exportPage: 'Выгрузить страницу',
    transactionInfo: 'Инфо о транзакции',
    of: 'из',
    columns: {
      description: 'Описание',
      transactionType: 'Тип транзакции',
      status: 'Статус',
      statusDescription: 'Описание статуса',
      merchantId: 'ID мерчанта',
      merchantName: 'Имя мерчанта',
      serviceId: 'ID сервиса',
      serviceName: 'Имя сервиса',
      agent: 'Агент',
      payGateCommission: 'Комиссия',
      serviceCommission: 'Комиссия сервиса',
      amount: 'Сумма',
      phone: 'Номер телефона',
      createdAt: 'Дата создания',
      updatedAt: 'Дата обновления',
    },
    modal: {
      description: 'Описание транзакции',
      transactionType: 'Тип транзакции',
      status: 'Статус',
      statusDescription: 'Описание статуса',
      merchantId: 'ID мерчанта',
      merchantName: 'Имя мерчанта',
      serviceId: 'ID сервиса',
      serviceName: 'Имя сервиса',
      agent: 'Агент',
      payGateCommission: 'Комиссия',
      serviceCommission: 'Комиссия сервиса',
      amount: 'Сумма',
      phone: 'Номер телефона',
      createdAt: 'Дата создания',
      updatedAt: 'Дата обновления',
    },
  },
  payout: {
    pageSize: 'Размер страницы',
    datePlaceholder: 'Введите дату',
    exportPage: 'Выгрузить страницу',
    transactionInfo: 'Инфо о транзакции',
    of: 'из',
    columns: {
      creditAmount: 'Сумма зачисления',
      totalAmount: 'Полная сумма',
      cardNumber: 'Номер карты',
      externalId: 'Внешний идентификатор',
      statusDescription: 'Описание статуса',
      status: 'Статус',
      createdAt: 'Дата создания',
      finishedAt: 'Дата завершения',
    },
    modal: {
      description: 'Описание транзакции',
      transactionType: 'Тип транзакции',
      status: 'Статус',
      statusDescription: 'Описание статуса',
      merchantId: 'ID мерчанта',
      merchantName: 'Имя мерчанта',
      serviceId: 'ID сервиса',
      serviceName: 'Имя сервиса',
      agent: 'Агент',
      payGateCommission: 'Комиссия PayGate',
      serviceCommission: 'Комиссия сервиса',
      amount: 'Сумма',
      phone: 'Номер телефона',
      createdAt: 'Дата создания',
      updatedAt: 'Дата обновления',
    },
  },
  errors: {
    error: 'Ошибка',
  },
}
